import clsx from 'clsx'
import { useMemo } from 'react'

export type Option = {
  value: string
  label: string
}

type Props = React.InputHTMLAttributes<HTMLSelectElement> & {
  options: Option[]
  value: string
  invalid: boolean
  onChange: (value: string) => void
}

export function TabSwitch({
  options,
  value,
  onChange,
  autoFocus,
  invalid,
  ...rest
}: Props) {
  const activeIndex = useMemo(
    () => options.findIndex(opt => opt.value === value),
    [options, value]
  )

  return (
    <div className="relative flex flex-row items-center rounded-small bg-background p-1">
      <select hidden {...rest} defaultValue={value} aria-invalid={invalid}>
        {options.map(opt => (
          <option key={opt.value} value={opt.value}></option>
        ))}
      </select>
      <div className="w-full relative flex flex-row items-center z-10">
        <div
          className="absolute rounded-xsmall h-full bg-primary transition-[left] pointer-events-none"
          style={{
            width: `${100 / options.length}%`,
            left: `${(activeIndex / options.length) * 100}%`
          }}
        />
        {options.map(function (option) {
          const isSelected = option.value === value

          return (
            <button
              key={option.value}
              type="button"
              tabIndex={0}
              onClick={() => onChange(option.value)}
              autoFocus={autoFocus && isSelected}
              className={clsx(
                'relative text-regular flex-1 z-10 py-2 px-4 transition-[color] rounded-xsmall',
                !isSelected && 'text-text',
                isSelected && 'text-white'
              )}
            >
              {option.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
